import { ERROR_CODES } from '@/model/ERROR_CODES'
import { UserName } from '@/model/UserName'

const NAME_PATTERN = /^[0-9A-Za-z-_]{3,20}$/i

/**
 * minimum requirements
 * @param s
 */
function validateNameAsync(s: string, checkCommonName: boolean): Promise<UserName> {
  // TODO unit test it !!!
  const name: UserName = {
    value: s,
    valid: true,
    errorCode: undefined,
    length: s.length >= 3,
    namePattern: NAME_PATTERN.test(s),
    isAvailable: false,
  }
  name.valid = name.length && name.namePattern
  return new Promise((res) => {
    if (!name.valid) {
      // if (name.value.length === 0) name.errorCode = ERROR_CODES.nameErrorUnknown
      if (!name.length) name.errorCode = ERROR_CODES.nameToShort
      else if (!name.namePattern) name.errorCode = ERROR_CODES.nameInvalid
      res(name)
    } else {
      if (!checkCommonName) {
        res(name)
        return
      }
      isNameInUse(s)
        .then((b) => {
          name.isAvailable = !b
          // this line can only be reached when all others are true - so isAvailable is the important flag here
          name.valid = name.isAvailable
          if (!name.isAvailable) {
            name.errorCode = ERROR_CODES.nameInuse
          }
          res(name)
        })
        .catch(() => {
          // ignore failing calls and accept them as correct
          name.isAvailable = true
          res(name)
        })
    }
  })
}
/**
 * value to accept submit
 * @param password
 */
function isNameInUse(name: string) {
  return fetch('/gd/rest/userRegistration/isCommonNameInUse/' + name, {
    cache: 'no-cache',
  })
    .then((response) => response.text())
    .then((data) => {
      return data !== 'false' ? true : false
    })
}
/**
 * maybe not needed anymore - the promise method is already in the component
 * @param email
 */
function evaluateName(userName: UserName): Promise<UserName> {
  return validateNameAsync(userName.value, true)
}

export { validateNameAsync, evaluateName, isNameInUse }
